import React from 'react';

/**
 * Generate a color based on the name to ensure consistency
 */
const generateColor = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const hue = hash % 360;
  return `hsl(${hue}, 65%, 55%)`;
};

/**
 * Extract initials from name (first letter of first and last name)
 */
const getInitials = (firstName = '', lastName = '', email = '') => {
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }
  if (firstName) {
    return firstName.charAt(0).toUpperCase();
  }
  if (email) {
    return email.charAt(0).toUpperCase();
  }
  return '?';
};

/**
 * Avatar component that shows initials in SVG format
 */
const AvatarInitials = ({ 
  firstName, 
  lastName, 
  email, 
  size = 100,
  fontSize,
  className = ''
}) => {
  const initials = getInitials(firstName, lastName, email);
  const backgroundColor = generateColor(`${firstName}${lastName}${email}`);
  const calculatedFontSize = fontSize || size * 0.4;

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      style={{ display: 'block' }}
    >
      <circle 
        cx={size / 2} 
        cy={size / 2} 
        r={size / 2} 
        fill={backgroundColor}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fill="white"
        fontSize={calculatedFontSize}
        fontWeight="600"
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        {initials}
      </text>
    </svg>
  );
};

export default AvatarInitials;
